import { combineReducers } from "redux";
import mediaReducer from "./mediaReducer"; // Import the media reducer
import startupReducer from "./startupReducer"; // Import the media reducer
import imageReducer from "./imageReducer";
import libraryCardReducer from "./libraryCardReducer";
import agentReducer from "./agentReducer";
import queueServicesReducer from "./queueServicesReducer"; // Import the queue services reducer
import newsGenerationReducer from "./newsGenerationReducer"; // Import the news generation reducer
import auroraSqlReducer from "./auroraSqlReducer"; // Import the aurora SQL reducer
import ragReducer from "./ragReducer"; // Import the RAG reducer
import aiAutomationReducer from "./aiAutomationReducer"; // Import the AI automation reducer
import n8nWorkflowReducer from "./n8nWorkflowReducer"; // Import the N8N workflow reducer
import apiKeyRegistrationReducer from "./apiKeyRegistrationReducer"; // Import the API key registration reducer
import workflowDesignSubmissionReducer from "./workflowDesignSubmissionReducer"; // Import the workflow design submission reducer

const rootReducer = combineReducers({
  media: mediaReducer, // Combine the media reducer
  startup: startupReducer, // Combine the startup reducer
  images: imageReducer,
  libraryCards: libraryCardReducer,
  agent: agentReducer,
  queueServices: queueServicesReducer, // Combine the queue services reducer
  newsGeneration: newsGenerationReducer, // Combine the news generation reducer
  auroraSql: auroraSqlReducer, // Combine the aurora SQL reducer
  rag: ragReducer, // Combine the RAG reducer
  aiAutomation: aiAutomationReducer, // Combine the AI automation reducer
  n8nWorkflow: n8nWorkflowReducer, // Combine the N8N workflow reducer
  apiKeyRegistration: apiKeyRegistrationReducer, // Combine the API key registration reducer
  workflowDesignSubmission: workflowDesignSubmissionReducer, // Combine the workflow design submission reducer
});

export default rootReducer;
